import React from 'react'
import Link from 'gatsby-link'
import styles from './index.module.css'

const IndexPage = () => (
  <div className={styles.homePage}>
    <p>
      Hi, I&rsquo;m <strong>Shane Korin</strong> and I make interactive digital
      software and stuff for the web.
    </p>
    <p>
      I run digital development studio{' '}
      <strong>
        <a target="_blank" href="http://distriqt.com">
          distriqt
        </a>
      </strong>{' '}
      with my friend and business partner Michael. We provide software
      development, plus contracting and consulting services for companies,
      agencies and direct clients.
    </p>
    <div className={styles.bottom}>
      <Link className={styles.link} to="/resume">
        My resume
      </Link>
      <Link className={styles.link} to="/contact">
        Get in touch
      </Link>
      <a
        className={styles.link}
        target="_blank"
        href="https://www.linkedin.com/in/koriner/"
      >
        LinkedIn
      </a>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js